import { Tracker } from '@aircall/tracker';

export const tracker = new Tracker({ key: process.env.REACT_APP_RUDDERSTACK_API_KEY as string });
